module.exports = __webpack_public_path__ + "img/DE00735.39dc594d.png";